import React from 'react';
import ReactDOM from 'react-dom';
import { Card, Collapse } from 'antd';

import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
// import style from './Sgicard.css'
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { getConstByKey } from './sgiBaseComp/SgiCommon';

class SgiCard extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            itemPanelType: "Card",//区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
            CardProps: { style: { height: "100%", width: "100%" }, bodyStyle: { height: "100%", width: "100%" } },//form属性
            CardItems: [], //card下控件数组
            CardItemsIndex: {},
            tabBarExtraContent: {},
            activeCardKey: '',
            allDidMountCallback: {}//用于存放子组件自定义渲染后事件
        };
    }

    /**
     * 根据描述创建form
     * @param {父组件} parentModule
     * @param {描述} moduleDesc
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    Card_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.CardItems = []; //再次渲染的时候清空
        this.state.CardItemsIndex = {};

        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.CardProps);
        //转换form公共属性
        //addCtnCommonAttribute(this, moduleDesc, this.state.CardProps);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.formProps, type);
        //组装form表单下的控件信息
        if (type !== "dnd") this.fitCardItems(moduleDesc, this.state.CardItems, this.state.CardItemsIndex, objFct, type);
        //组装tabBarExtraContent下的控件
        this.fitTabExtraContent(moduleDesc, this.state.tabBarExtraContent, objFct, type);
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} formProps
     */
    bindEvent(moduleDesc, formProps, type) {
        //拖拽模式 不生成事件
        if (type == 'dnd') {
            return;
        }
    }


    /**
     * 根据描述组装子 操作按钮
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    fitTabExtraContent = function (moduleDesc, CardItems, objFct, type) {
        var me = this;
        // tabBarExtraContent
    }

    /**
    * 根据描述组装子对象
    * @param {描述信息} moduleDesc
    * @param {属性} formProps
    */
    fitCardItems = function (moduleDesc, CardItems, CardItemsIndex, objFct, type) {
        var me = this;

        let cldSet = moduleDesc.cldSet;
        if (cldSet && cldSet.length && cldSet.length > 0) {
            const isAsyn = moduleDesc.isAsyn;
            if (isAsyn) {
                // 异步加载其他面板，仅加载初始/第一个面板
                const { activeCardKey } = this.state;
                if (activeCardKey) {
                    // 加载指定面板
                    cldSet.some((item, index) => {
                        const cId = getConstByKey(this, item.cId);
                        if (cId === activeCardKey) {
                            CardItems.push(convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem }));
                            CardItemsIndex[cId] = CardItems.length - 1;
                            return true;
                        }
                    });
                } else {
                    // 加载第一个面板 //不指定页面则不再进行初始加载，因为没有用
                    // const first = cldSet[0];
                    // CardItems.push(convertModuleByGuid(me, first, null, objFct, type, { setActiveWV: this.setActiveItem }));
                    // CardItemsIndex["0"] = 0;
                }
            } else {
                // 同步加载所有面板
                cldSet.forEach((item, index) => {
                    // let { cId } = item;
                    let cId = getConstByKey(this, item.cId);
                    if (index == 0 && !this.state.activeCardKey) {
                        this.state.activeCardKey = cId ? cId : index
                    }
                    // item.isCardPanel = true; //如果是重叠下的panel特殊处理
                    if (cId) {
                        CardItemsIndex[cId] = index;
                    } else {
                        CardItemsIndex[index + ""] = index;
                    }
                    CardItems.push(convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem }));
                });
            }
        }
    }

    setActiveItem = (activeCardKey, didMountCallback) => {
        this.state.activeCardKey = activeCardKey;
        this.state.allDidMountCallback[activeCardKey] = didMountCallback;
        this.setState({});
    }
    /**
     * 获取当前激活面板的组件标识
     * @return {[type]} [description]
     */
    getActiveItem = () => {
        return this.state.activeCardKey;
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded || this.props.type == 'dnd') {
            //组装属性
            this.Card_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        const { isAsyn, CardItems, CardItemsIndex, activeCardKey, allDidMountCallback } = this.state;

        // 是否需要异步加载页面
        if (isAsyn && isNaN(CardItemsIndex[activeCardKey])) {
            // 异步加载面板
            const cldSet = moduleDesc.cldSet || [];
            const me = this;
            cldSet.some((item, index) => {
                const cId = getConstByKey(this, item.cId);
                if (cId === activeCardKey) {
                    // 创建组件
                    const son = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem, didMountCallback: allDidMountCallback[activeCardKey] });
                    CardItems.push(son);
                    CardItemsIndex[cId] = CardItems.length - 1;
                    // 注册组件
                    ComponentManager.set(objFct.getUID(), cId, son);
                    // 返回
                    return true;
                }
            });
        }

        //根据当前激活的面板，将另外2个面板设置不可见
        let showItems = [];
        let activeIndex = CardItemsIndex[activeCardKey];
        CardItems.forEach((item, index) => {
            if (index === activeIndex) {
                showItems.push(<div style={{ height: "100%", width: '100%' }}>{item}</div>)
            } else {
                showItems.push(<div style={{ height: "100%", width: '100%', display: "none" }}>{item}</div>)
            }
        })

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.CardProps);

        return (
            <Card {...this.state.CardProps}>
                {showItems}
            </Card>
        )
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    AddAttribute = function (moduleDesc, CardProps) {
        //初始化激活的面板
        let atvTab = getConstByKey(this, moduleDesc.atvTab);
        if (atvTab) {
            this.state.activeCardKey = atvTab;
        }

        let isBrdr = moduleDesc.isBrdr; //是否有边框
        if (isBrdr) {
            CardProps.bordered = true;
        } else {
            CardProps.bordered = false;
        }

        if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
            let title = Resource.getTRByPrm(moduleDesc).te; //是否有标题
            if (title) CardProps.title = title;
        }

        var cId = moduleDesc.cId; //cid 唯一标示
        if (cId) CardProps.id = getConstByKey(this, cId);

        var ctlW = moduleDesc.ctlW; //form宽度
        if (ctlW) CardProps.style.width = ctlW;

        var ctlH = moduleDesc.ctlH; //form高度
        if (ctlH) CardProps.style.height = ctlH;

        var mgn = moduleDesc.mgn; //form外边距
        if (mgn) CardProps.bodyStyle.margin = mgn;
        var pad = moduleDesc.pad; //form内边距
        if (pad) CardProps.bodyStyle.padding = pad;

        var isHdn = moduleDesc.isHdn; //form是否隐藏
        if (isHdn) CardProps.style.display = "none";

        CardProps.hoverable = false;//鼠标滑过 是否浮动，默认现在不浮动

        var isScl = moduleDesc.isScl; //滚动
        if (isScl) {
            CardProps.style.overflow = "auto";
        } else {
            CardProps.style.overflow = undefined;
        }

        // 是否异步加载其余页面
        this.state.isAsyn = !!moduleDesc.isAsyn;
    }
}

//给类添加公共方法
Object.assign(SgiCard.prototype, sgiCtnBaseFun);
export { SgiCard };
export default SgiCard;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCard.js